import { render, staticRenderFns } from "./QuestTask.vue?vue&type=template&id=d9b54c90&scoped=true"
import script from "./QuestTask.vue?vue&type=script&lang=js"
export * from "./QuestTask.vue?vue&type=script&lang=js"
import style0 from "./QuestTask.vue?vue&type=style&index=0&id=d9b54c90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9b54c90",
  null
  
)

export default component.exports